/**
 * Collection Item Card
 *
 * Custom element for the collection-page product card.
 * Keeps the stretch-link from swallowing cart / quick-buy controls,
 * and tears down listeners when the node is removed (section reload).
 */
(function () {
  'use strict';

  const INTERACTIVE_SELECTOR = 'a, button, input, select, textarea, [role="button"]';

  /**
   * Collection listing product card.
   */
  class CollectionItemCard extends HTMLElement {
    connectedCallback() {
      this._onPointerDown = this._handlePointerDown.bind(this);
      this.addEventListener('pointerdown', this._onPointerDown);
    }

    disconnectedCallback() {
      this.removeEventListener('pointerdown', this._onPointerDown);
    }

    /**
     * Stop the overlay link from receiving the click when the user
     * interacts with the add-to-cart control or the quick-buy drawer.
     * @param {PointerEvent} event
     */
    _handlePointerDown(event) {
      const interactive = event.target.closest(INTERACTIVE_SELECTOR);
      if (!interactive || interactive === this.querySelector('.collection-item-card__stretch-link')) {
        return;
      }
      event.stopPropagation();
    }
  }

  if (!window.customElements.get('collection-item-card')) {
    window.customElements.define('collection-item-card', CollectionItemCard);
  }
})();
